@if (helpentryId > 0) {
  <div class="cw-module-card">
    <div class="cw-flex-column">
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>{{ 'GLOBAL.HELP.MODULES.MODULEASSIGNMENT' | translate }}</h2>
        <!--Toolbar -->
        @if (!editMode) {
          <phscw-toolbar
            componentIdentifier="global-help-modules"
            [componentConnection]="$any(this)"
            [buttonAdd]="true">
          </phscw-toolbar>
        }
      </div>
      <!-- Select Box über Grid anzeigen -->
      @if (editMode) {
        <form #globalHelpModulesForm="ngForm" (ngSubmit)="clickSubmit()">
          <!-- Eingabefelder -->
          <phscw-input-select
            [editMode]="editMode"
            label="{{ 'GLOBAL.HELP.MODULES.SELECTMODULE' | translate }}"
            name="roleId"
            inputId="roleId"
            [(ngModel)]="modulesDataItem.id"
            [selectData]="selectModule">
          </phscw-input-select>
          <!-- Buttons Submit & Cancel (für EditMode) -->
          @if (editMode) {
            <div class="cw-button-wrapper">
              <button
                mat-raised-button
                color="accent"
                type="submit"
                [disabled]="!globalHelpModulesForm.form.valid || loading || saving">
                {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
              </button>
              <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
                {{ 'GENERAL.CANCEL' | translate }}
              </button>
            </div>
          }
        </form>
      }
      <div class="cw-submodules">
        <div class="cw-submodule">
          <!-- Submodul-Titel -->
          <div class="cw-horizontalline"></div>
          <!-- Grid -->
          <phscw-grid
            class="globalHelpModulesGrid"
            #globalHelpModules
            gridId="globalHelpModules"
            [simpleGrid]="true"
            [gridData]="data"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridDisplayedColumns">
          </phscw-grid>
          @if (loading) {
            <div class="cw-global-search-icon icon-spinner icon-spin"></div>
          }
        </div>
      </div>
    </div>
  </div>
}
